__turbopack_context__.v({
  "className": "roboto_bd5f237e-module__OR32JW__className",
  "variable": "roboto_bd5f237e-module__OR32JW__variable",
});
